import script from "./ReceiptHeaderSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReceiptHeaderSetting.vue?vue&type=script&lang=ts&setup=true"

import "./ReceiptHeaderSetting.vue?vue&type=style&index=0&id=e9412650&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9412650"]])

export default __exports__